<script>
import { fandomBasicMixin, fandomExtendedMixin } from "src/modules/fandom_mixins_module.js";

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin],
  data() {
    return {
      dataModel: []
    }
  },
  mounted() {
    this.initFilters();
    if (this.content.$id) {
      console.log(`%Warning\n\tmessage: contents with layout 'grid-filter' should be standalone contents, in order to prevent depth conflicts`, "color: yellow");
    }
  },
  methods: {
    initFilters() {
      const params = new URLSearchParams(window.location.search);
      const filters = params.get('filters');
      if (!!filters) {
        this.dataModel = JSON.parse(filters);
        this.updateFilters();
      } else {
        this.content.items.forEach((filter, index) => {
          Vue.set(this.dataModel, index, []);
        });
      }
    },
    updateFilters() {
      Fandom.emit('grid-filter-apply', {
        contentFiltering: this.dataModel,
        handlerContents: (this.content.handler_contents || "")
      }); 
    }
  }
};

</script>

<template>
  <div 
    v-if="isContentVisibleToUser()" 
    v-easyadmin="easyadminId" 
    :class="[contentType, paddingY]"
    grid-filter-component
  >
    <slot name="grid-filter-header"></slot>
    <div class="container-fluid grid-filter-body">
      <div class="row">
        <div class="col-12 px-4">
          <div class="accordion">
            <div class="card pt-2" v-for="(item, index) in content.items" :key="`group-${index}`">
              <div class="card-header px-0" :id="`heading-${item.$id}`">
                <h2 class="mb-0">
                  <button class="btn btn-block p-0 d-flex justify-content-between" type="button" data-toggle="collapse" :data-target="`#collapse-${item.$id}`" aria-expanded="true" :aria-controls="`collapse-${item.$id}`">
                    {{item.title}}<i class="icon ml-3 mt-1 far fa-angle-down"></i>
                  </button>
                </h2>
              </div>
              <div :id="`collapse-${item.$id}`" class="collapse show" :aria-labelledby="`heading-${item.$id}`">
                <div class="card-body px-0 pt-1 pb-4" :class="{'d-flex flex-wrap justify-content-start': item.show_as_tags}">
                  <div 
                    class="custom-control"
                    :class="item.show_as_tags ? 'custom-tag' : 'custom-checkbox'"
                    v-for="(filter, filterIndex) in item.filter_contents"
                    :key="`tag-group-${item.title}-${filterIndex}`"
                  >
                    <input 
                      type="checkbox"
                      :value="filter"
                      class="custom-control-input"
                      :id="`tag-group-${item.title}-${filterIndex}`"
                      v-model="dataModel[index]"
                      @change="updateFilters"
                    >
                    <label
                      :class="{'font-weight-bold': dataModel[index] && dataModel[index].includes(filter)}"
                      class="custom-control-label" 
                      :for="`tag-group-${item.title}-${filterIndex}`"
                    >{{getContent(filter).title}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot name="grid-filter-footer"></slot>
  </div>
</template>

<style lang="scss" scoped>
[grid-filter-component] {
  .card {
    border: none;
    border-radius: 0;
    border-bottom: 1px solid $gray-500;

    @include media-breakpoint-up(md) {
      &:last-child {
        border-bottom: none;
      }
    }

    &-header {
      border: none;
      background-color: $white;

      .btn {
        font-size: $h4-font-size;
        font-weight: 800;

        &:focus {
          box-shadow: none;
        }

        .icon {
          transition: transform 0.2s ease-in-out;
        }

        &:not(.collapsed) .icon {
          transform: rotate(-180deg);
        }
      }
    }
  
    &-body {
      .custom-control:not(:last-child):not(.custom-tag) {
        padding-bottom: .5rem;
      }

      .custom-tag {
        padding-left: 0;

        .custom-control-input:checked {
          ~ .custom-control-label {
            background-color: $dark;
            color: $white;
          } 
        }

        .custom-control-label {
          font-size: $h6-font-size;
          padding: .5rem 1rem;
          border-radius: 3rem;
          transition: all .25s;
          margin: 0 .25rem .5rem .25rem;
          border: 1px solid $dark;
          font-weight: bold;
          cursor: pointer;

          &::before, &::after {
            content: none;
          }
        }
      }

      .custom-control-input {
        background-color: $white;

        ~ .custom-control-label {
          color: $dark;

          &::before {
            border-color: $dark;
          }
        }

        &:focus {
          ~ .custom-control-label::before {
            box-shadow: none;
          }

          &:not(.checked) ~ .custom-control-label::before {
            border-color: $dark;
          }
        }

        &:checked, &:active { 
          ~ .custom-control-label::before {
            background-color: $dark;
            border-color: $dark;
            box-shadow: none;
          }
        }
      }
    }
  }

  @include media-breakpoint-down(md) {
    .grid-filter-body {
      height: 100vh;
      overflow-x: hidden;
      overflow-y: scroll;
    }
  }
}
</style>
